import {AssetMap} from "types";

export const assets3D: AssetMap[] = [
    // {
    //     targetIndex: 0,
    //     glbModelSrc: '/models3D/ZONE_accenture-tube.glb'
    // },
    // {
    //     targetIndex: 1,
    //     glbModelSrc: '/models3D/ZONE_time-wrap.glb'
    // },
    // {
    //     targetIndex: 2,
    //     glbModelSrc: '/models3D/ZONE_haptic-fix.glb'
    // },
    // {
    //     targetIndex: 3,
    //     glbModelSrc: '/models3D/ZONE_vr.glb'
    // },
    // {
    //     targetIndex: 4,
    //     glbModelSrc: '/models3D/bacsd-fp.glb'
    // },
    // {
    //     targetIndex: 5,
    //     glbModelSrc: '/models3D/bacls-hbps.glb'
    // },
    // {
    //     targetIndex: 6,
    //     glbModelSrc: '/models3D/bublp-lm.glb'
    // },
    // {
    //     targetIndex: 7,
    //     glbModelSrc: '/models3D/bcp-acqua.glb'
    // },
    // {
    //     targetIndex: 8,
    //     glbModelSrc: '/models3D/ZONE_digital-gallery.glb'
    // },
    // {
    //     targetIndex: 9,
    //     glbModelSrc: '/models3D/brlp-nht.glb'
    // },
    // {
    //     targetIndex: 10,
    //     glbModelSrc: '/models3D/bcp-c2d.glb'
    // },
    // {
    //     targetIndex: 11,
    //     glbModelSrc: '/models3D/bcp-rcd.glb'
    // },
    // {
    //     targetIndex: 12,
    //     glbModelSrc: '/models3D/bug-eil.glb'
    // },
    // {
    //     targetIndex: 13,
    //     glbModelSrc: '/models3D/buv-vbt.glb'
    // },
    // {
    //     targetIndex: 14,
    //     glbModelSrc: '/models3D/bapa-cb.glb'
    // },
    // {
    //     targetIndex: 15,
    //     glbModelSrc: '/models3D/blt-acd.glb'
    // },
    // {
    //     targetIndex: 16,
    //     glbModelSrc: '/models3D/blt-ccls.glb'
    // },
    // {
    //     targetIndex: 17,
    //     glbModelSrc: '/models3D/buvw-l2b.glb'
    // },
    // {
    //     targetIndex: 18,
    //     glbModelSrc: '/models3D/buvw-3tec.glb'
    // },
    // {
    //     targetIndex: 19,
    //     glbModelSrc: '/models3D/ZONE_typing-tutor.glb'
    // }
];